import React from 'react';

export default function AppCrashed(props: { eventId?: string }) {
  const { eventId } = props || {};
  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, Helvetica, Arial, sans-serif' }}>
      <h1 style={{ fontSize: 20, marginBottom: 8 }}>Something went wrong</h1>
      <p style={{ margin: '8px 0 16px' }}>
        An unexpected error occurred. Please try refreshing the page. If the problem persists, contact support.
      </p>
      {eventId ? (
        <p style={{ color: '#666', fontSize: 13 }}>
          Error reference: <code>{eventId}</code>
        </p>
      ) : null}
      <button onClick={() => window.location.reload()} style={{ marginTop: 12, padding: '8px 12px' }}>
        Reload
      </button>
    </div>
  );
}


